export { Text, type TextProps } from './styled/text';
